// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

.content {
  height: 100%;
  margin: 0;
  overflow: hidden;
}

ngx-monaco-editor {
  object-fit: fill;
  height: calc(100vh - 100px) !important;
}

.progress {
  margin-bottom: 5px;
  font-size: 15px;
}

.save-error {
  margin-bottom: 5px;
  font-size: 15px;
  color: red;
}

a.save-error {
  text-decoration: none;
}

a.save-error:hover {
  -webkit-text-decoration: under;
          text-decoration: under;
}

.isDisabled {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.5;
  text-decoration: none;
}

.new {
  font-style: italic;
  color: rgba(0, 0, 0, 0.5);
}

.fix-padding {
  padding: 0.6em 0 0 0 !important;
}

.tags-list {
  width: 100%;
}

.fix-align {
  margin-left: -4px;
  text-align: left;
}

form {
  box-sizing: border-box;
  min-width: 430px;
  overflow-y: auto;
  flex: 1;
  min-height: 0; /* Allow flex item to shrink below content size for scrolling */
  scrollbar-width: thin !important;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent !important;
}
form::-webkit-scrollbar {
  width: 8px !important;
  height: 8px !important;
}
form::-webkit-scrollbar-track {
  background: transparent !important;
}
form::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7) !important;
  border-radius: 4px !important;
}
form::-webkit-scrollbar-thumb:hover {
  background: rgba(155, 155, 155, 0.9) !important;
}
form::-webkit-scrollbar-corner {
  background: transparent !important;
}
form:not(.no-padding) {
  padding: var(--content-margin);
}

.mat-drawer-container {
  height: 100%;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
}

mat-drawer {
  max-width: 450px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.panel-head {
  width: 100%;
  padding: 4px;
  text-align: center;
  font-family: var(--font-mono);
}

.divider {
  height: 10px;
}

textarea {
  width: 419px;
  height: 444px;
  margin-top: 10px;
}

.progress-column {
  display: flex;
  flex-direction: column;
}

.progress-bar-row {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
}

.progress-text-row {
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  font-size: 11pt;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.success-row {
  display: flex;
  flex-direction: row;
}

.success-text {
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  font-size: 11pt;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.success {
  color: green;
  display: flex;
  flex-direction: column;
  margin-right: 3px;
}

.component-buttons {
  padding: 0 var(--content-margin) var(--content-margin);
}

mat-icon.smol {
  height: 18px;
  width: 18px;
  font-size: 18px;
}

button.smol {
  min-height: 36px;
  --mat-menu-item-label-text-size: 14px;
}

.settings-divider {
  margin: 20px 0 15px;
}

.settings-section-label {
  font-size: 0.75em;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/models/definition/definition.component.scss"],"names":[],"mappings":"AA6BA;EACE,cAAA;EACA,YAAA;AA5BF;;AA+BA;EACE,YAAA;EACA,SAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,gBAAA;EACA,sCAAA;AA5BF;;AA+BA;EACE,kBAAA;EACA,eAAA;AA5BF;;AA+BA;EACE,kBAAA;EACA,eAAA;EACA,UAAA;AA5BF;;AA+BA;EACE,qBAAA;AA5BF;;AA+BA;EACE,8BAAA;UAAA,sBAAA;AA5BF;;AA+BA;EACE,mBAAA;EACA,oBAAA;EACA,YAAA;EACA,qBAAA;AA5BF;;AA+BA;EACE,kBAAA;EACA,yBAAA;AA5BF;;AA+BA;EACE,+BAAA;AA5BF;;AA+BA;EACE,WAAA;AA5BF;;AA+BA;EACE,iBAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,OAAA;EACA,aAAA,EAAA,+DAAA;EA3FA,gCAAA;EACA,gEAAA;AAgEF;AA9DE;EACE,qBAAA;EACA,sBAAA;AAgEJ;AA7DE;EACE,kCAAA;AA+DJ;AA5DE;EACE,+CAAA;EACA,6BAAA;AA8DJ;AA5DI;EACE,+CAAA;AA8DN;AA1DE;EACE,kCAAA;AA4DJ;AAYE;EACE,8BAAA;AAVJ;;AAcA;EACE,YAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;AAXF;;AAcA;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAXF;;AAeA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;AAZF;;AAeA;EACE,YAAA;AAZF;;AAeA;EACE,YAAA;EACA,aAAA;EACA,gBAAA;AAZF;;AAeA;EACE,aAAA;EACA,sBAAA;AAZF;;AAeA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,iDAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;AAZF;;AAeA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;EACA,iDAAA;AAZF;;AAeA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AAZF;;AAeA;EACE,sDAAA;AAZF;;AAeA;EACE,YAAA;EACA,WAAA;EACA,eAAA;AAZF;;AAeA;EACE,gBAAA;EACA,qCAAA;AAZF;;AAeA;EACE,mBAAA;AAZF;;AAeA;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;AAZF","sourcesContent":["// Scrollbar styling - use rgba values for reliable cross-theme support\n// Needs !important to override global preset styles in styles.scss\n@mixin themed-scrollbar {\n  scrollbar-width: thin !important;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent !important;\n\n  &::-webkit-scrollbar {\n    width: 8px !important;\n    height: 8px !important;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent !important;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(155, 155, 155, 0.7) !important;\n    border-radius: 4px !important;\n\n    &:hover {\n      background: rgba(155, 155, 155, 0.9) !important;\n    }\n  }\n\n  &::-webkit-scrollbar-corner {\n    background: transparent !important;\n  }\n}\n\n:host {\n  display: block;\n  height: 100%;\n}\n\n.content {\n  height: 100%;\n  margin: 0;\n  overflow: hidden;\n}\n\nngx-monaco-editor {\n  object-fit: fill;\n  height: calc(100vh - 100px) !important;\n}\n\n.progress {\n  margin-bottom: 5px;\n  font-size: 15px;\n}\n\n.save-error {\n  margin-bottom: 5px;\n  font-size: 15px;\n  color: red;\n}\n\na.save-error {\n  text-decoration: none;\n}\n\na.save-error:hover {\n  text-decoration: under;\n}\n\n.isDisabled {\n  cursor: not-allowed;\n  pointer-events: none;\n  opacity: 0.5;\n  text-decoration: none;\n}\n\n.new {\n  font-style: italic;\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.fix-padding {\n  padding: 0.6em 0 0 0 !important;\n}\n\n.tags-list {\n  width: 100%;\n}\n\n.fix-align {\n  margin-left: -4px;\n  text-align: left;\n}\n\nform {\n  box-sizing: border-box;\n  min-width: 430px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0; /* Allow flex item to shrink below content size for scrolling */\n  @include themed-scrollbar;\n\n  &:not(.no-padding) {\n    padding: var(--content-margin);\n  }\n}\n\n.mat-drawer-container {\n  height: 100%;\n  user-select: none;\n  position: relative;\n}\n\nmat-drawer {\n  max-width: 450px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n\n.panel-head {\n  width: 100%;\n  padding: 4px;\n  text-align: center;\n  font-family: var(--font-mono);\n}\n\n.divider {\n  height: 10px;\n}\n\ntextarea {\n  width: 419px;\n  height: 444px;\n  margin-top: 10px;\n}\n\n.progress-column {\n  display: flex;\n  flex-direction: column;\n}\n\n.progress-bar-row {\n  margin-top: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.progress-text-row {\n  display: flex;\n  flex-direction: row;\n  margin-top: 5px;\n  font-size: 11pt;\n  font-family: Roboto, 'Helvetica Neue', sans-serif;\n}\n\n.success-row {\n  display: flex;\n  flex-direction: row;\n}\n\n.success-text {\n  display: flex;\n  flex-direction: column;\n  margin-top: 5px;\n  font-size: 11pt;\n  font-family: Roboto, 'Helvetica Neue', sans-serif;\n}\n\n.success {\n  color: green;\n  display: flex;\n  flex-direction: column;\n  margin-right: 3px;\n}\n\n.component-buttons {\n  padding: 0 var(--content-margin) var(--content-margin);\n}\n\nmat-icon.smol {\n  height: 18px;\n  width: 18px;\n  font-size: 18px;\n}\n\nbutton.smol {\n  min-height: 36px;\n  --mat-menu-item-label-text-size: 14px;\n}\n\n.settings-divider {\n  margin: 20px 0 15px;\n}\n\n.settings-section-label {\n  font-size: 0.75em;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
